export const ANNOUNCEMENT_HIDE_PREFIX = 'announcement_hide_';
export const ANNOUNCEMENT_SEEN_PREFIX = 'announcement_seen_';
export const MAX_VISIBLE_ANNOUNCEMENT_STACK = 3;

export const buildAnnouncementLocalDate = (dateTimeStr) => {
  if (!dateTimeStr) return null;
  const normalized = String(dateTimeStr).replace('T', ' ').slice(0, 19);
  const [datePart, timePart] = normalized.split(' ');
  if (!datePart) return null;
  const [year, month, day] = datePart.split('-').map(Number);
  const timeParts = (timePart || '00:00:00').split(':');
  const hours = Number(timeParts[0] || 0);
  const minutes = Number(timeParts[1] || 0);
  const seconds = Number(String(timeParts[2] || '0').split('.')[0]);
  return new Date(year, month - 1, day, hours, minutes, seconds);
};

export const isAnnouncementInValidPeriod = (announcement) => {
  const start = buildAnnouncementLocalDate(announcement?.start_at);
  const end = buildAnnouncementLocalDate(announcement?.end_at);
  if (!start || !end) return false;
  const now = Date.now();
  return now >= start.getTime() && now <= end.getTime();
};

export const normalizeAnnouncementList = (data) => {
  if (Array.isArray(data)) return data;
  if (data && typeof data === 'object') return [data];
  return [];
};

export const isAnnouncementHidden = (announcement) => {
  if (!announcement?.id) return false;
  try {
    const stored = localStorage.getItem(`${ANNOUNCEMENT_HIDE_PREFIX}${announcement.id}`);
    if (!stored) return false;
    const { updated_at: updatedAt } = JSON.parse(stored);
    return updatedAt === announcement.updated_at;
  } catch {
    return false;
  }
};

export const isAnnouncementSeenThisSession = (announcement) => {
  if (!announcement?.id) return false;
  try {
    const stored = sessionStorage.getItem(`${ANNOUNCEMENT_SEEN_PREFIX}${announcement.id}`);
    if (!stored) return false;
    const { updated_at: updatedAt } = JSON.parse(stored);
    return updatedAt === announcement.updated_at;
  } catch {
    return false;
  }
};

export const shouldShowAnnouncement = (announcement) => {
  if (!announcement) return false;
  return !isAnnouncementHidden(announcement) && !isAnnouncementSeenThisSession(announcement);
};
